import { Injectable } from '@angular/core';
import {
  BudgetControl,
  WhtNumberTypes,
} from '@shared/models/budget-request.model';
import {
  calculateAll,
  calculateBudgetControl,
  calculateLineItem,
  calculateTotalForManualUpdate,
  getSelectedWhtNumberTypes,
} from '@shared/utils/budget-request.util';

@Injectable({
  providedIn: 'root',
})
export class BudgetRequestService {
  constructor() {}

  calculateLineItem(item: Parameters<typeof calculateLineItem>[0]) {
    calculateLineItem(item);
  }

  calculateAll(items: Parameters<typeof calculateAll>[0]) {
    return calculateAll(items);
  }

  calculateTotalForManualUpdate(
    sub_total: Parameters<typeof calculateTotalForManualUpdate>[0],
    fields: Parameters<typeof calculateTotalForManualUpdate>[1],
  ) {
    return calculateTotalForManualUpdate(sub_total, fields);
  }

  getSelectedWhtNumberTypes(
    items: Parameters<typeof getSelectedWhtNumberTypes>[0],
  ): WhtNumberTypes[] {
    return getSelectedWhtNumberTypes(items);
  }

  calculateBudgetControl(
    item: Parameters<typeof calculateBudgetControl>[0],
  ): BudgetControl {
    return calculateBudgetControl(item);
  }
}
